import React, { useEffect, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import ReactInputMask from "react-input-mask";
import CustomFieldPopover from './CustomFieldPopover';
import { displayValueForTimeEntry, getDecimalFromTime, convertDecimalToTimeOnValidation } from '../../common/timesheetFunction';
import {
    addUpdateAccountEmployeeTimeEntryAsync, addCopyAccountEmployeeTimeEntryAsync, updateDetailFieldsByDetailRowId, updateIsReload, updateTimeEntriesAsync,
    updateInValidTimeError, updateValidTimeError, updateTabIndex, updateRefreshPrint,updateIsStateHour,updateIsStateMinute
} from './timesheetSlice';
import { TimesheetUpdateClass } from '../../interfaces/TimesheetUpdateClass';
import { ShowToast } from '../../common/Toastr';
import { ShowSwalWithConfirmation } from '../../common/SweetAlert';
import clsx from 'clsx';
import { FormatInvoiceDecimalNumber, getDecimalSeparator,FormatInvoiceDecimalNumberWithTwoDigitInteger, determineCommaSeprater } from '../../common/timeLiveFunction';
// import { useEventListener } from '../../common/hook/useEventListener';
import ChangelogReasonModal from './ChangeLogReasonModal';

export interface Selection {
    start: number;
    end: number;
}

export interface InputState {
    value: string;
    selection: Selection | null;
}

export interface BeforeMaskedStateChangeStates {
    previousState: InputState;
    currentState: InputState;
    nextState: InputState;
}
let isClearedWithBackspace: boolean = false;
let oldTimeEntryValue: string = "";
let isClickTimeValue: boolean = false;
let tempHourValue = 0;
let lastKeyName = "";
// let isTimesheetLocked: boolean = false;
let lastInsertedMinutes = 0;
let updatedValue = "";
let cursorPos = 0;
 let isAllowEntries = false;

const TimeEntryInput = (props: any) => {
    const dispatch = useAppDispatch();
    const { timeZoneId } = useAppSelector((state) => state.globalState)
    const { customFieldsTemplate, decimalFormat, accountEmployeeTimeEntryPeriodId, accountEmployeeId, startDate, endDate, timeEntryViewType, timeEntriesList, isTimesheetPolicy, isLocked, showClockStartEnd,
        showWorkType, defaultWorkTypeId, isCopyActivities, isAllowOverlappingTimeEntries, fromTabIndex, isStateHour,isStateMinute,totalHours } = useAppSelector(state => state.timesheet);
    const { allowZeroHoursInTimesheet,cultureInfoName,decimalPlaces, IsTimesheetChangelogEnabled } = useAppSelector((state) => state.globalState);
    const { rowId, detailRowId, showRelative } = props;
    const currentRow = timeEntriesList.find(x => x.rowId === rowId);    
    const currentDetailRow = currentRow.timeEntries[detailRowId];
    const node = useRef<any>();
    const inputRef = useRef<any>();
    const popoverRef = useRef<any>();
    const [visible, setVisible] = useState(false);
    const [validTime, setValidTime] = useState(false);
    const [validationEnable, setValidationEnable] = useState(false);
    const [timeEntryHours, setTimeEntryHours] = useState<string | number>(decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, 2): 0);
    const [allowInReactMask, setAllowInReactMask] = useState<string | number>(0);
    const [rawDigits, setRawDigits] = useState("");
    const [showpopover, setShowPopover] = useState(false);
    let keyPressedName: string = ""; 
    const [isChangelogModalOpen, setIsChangelogModalOpen] = useState(false);
    const [pendingUpdateData, setPendingUpdateData] = useState<{ hoursValue: number; customFieldValues: any } | null>(null);
    


    const formatlabel = getDecimalSeparator(cultureInfoName.toString());
  
    const handleClick = (e: any) => {
     
        if (node.current.contains(e.target)) {     
             
            // inside click
            return;
        }
        if (!node.current.contains(e.target)
        ) {
            //Clicked Outside
            // if ((popoverRef.current || fromTabIndex) && popoverRef.current != undefined) {
            if (popoverRef.current) {       
                const isChanged = popoverRef.current.getIsChanged();
                let hoursFromPopup = popoverRef.current.getTotalTimeValue();
                const customFieldValues = popoverRef.current.getCustomFieldValues();
                 // console.log('Converted hoursFromPopup:', hoursFromPopup);
               if (typeof hoursFromPopup === "string") {
                const isComma = determineCommaSeprater(cultureInfoName.toString());
                if (isComma) {
                    hoursFromPopup = hoursFromPopup.replace(',', '.');
                }
            }
             if (inputRef.current && typeof inputRef.current.value === "string") {
                const isComma = determineCommaSeprater(cultureInfoName.toString());
                if (isComma) {
                    inputRef.current.value = inputRef.current.value.replace(',', '.');
                }
            }

            // console.log('Converted hoursFromPopup:', hoursFromPopup);
            // console.log('Converted inputRef value:', inputRef.current.value);

            //  console.log('nputRef.current.value:', inputRef.current.value);

                // const hoursValue = fixAndSetHoursValue((showClockStartEnd && !decimalFormat ? hoursFromPopup : inputRef.current.value));  
                const rawInputValue = showClockStartEnd && !decimalFormat ? hoursFromPopup : inputRef.current.value;
                const isPlaceholder = typeof rawInputValue === "string" && (rawInputValue === "__:__" || rawInputValue === "__.__" || rawInputValue.includes("_"));
                const hoursValue = isPlaceholder ? 0 : fixAndSetHoursValue(rawInputValue);                            
                if (hoursValue == 0 && currentDetailRow.Hours != 0 && currentDetailRow.AccountEmployeeTimeEntryId) {                            
                    oldTimeEntryValue = inputRef.current.value;
                    if (allowZeroHoursInTimesheet && !isClearedWithBackspace) {
                        isClickTimeValue && addUpdateTimeEntries(hoursValue, customFieldValues);
                        // oldTimeEntryValue = inputRef.current.value;
                    } else if (allowZeroHoursInTimesheet && isClearedWithBackspace) {
                        removeTimeEntries();
                    } else {
                        if (!allowZeroHoursInTimesheet && isClearedWithBackspace) {
                            removeTimeEntries();
                        } else {
                            ShowToast('Warning', "Zero hour time entry cannot be added or updated", "warning", "toast-top-right");
                            setTimeEntryHours(oldTimeEntryValue);
                        }
                        // ShowSwalWithConfirmation('Are you sure?', "You won't be able to revert this!")
                        //     .then((result) => {
                        //         if (result) {
                        //             const { AccountClientId, AccountProjectId, AccountProjectTaskId, AccountEmployeeTimeEntryApprovalProjectId } = currentRow;
                        //             const postObject = {
                        //                 AccountEmployeeId: accountEmployeeId,
                        //                 AccountClientId,
                        //                 AccountProjectId,
                        //                 AccountProjectTaskId,
                        //                 ApprovalProjectId: AccountEmployeeTimeEntryApprovalProjectId,
                        //                 AccountEmployeeTimeEntryPeriodId: accountEmployeeTimeEntryPeriodId,
                        //                 TimeEntries: [currentDetailRow.AccountEmployeeTimeEntryId],
                        //                 IsTimeOff: currentRow.isTimeOff === "1" ? true : false,
                        //                 IsDelete: true
                        //             }
                        //             dispatch(updateTimeEntriesAsync({ RowId: rowId, ...postObject }))
                        //                 .unwrap()
                        //                 .then((originalPromiseResult) => {
                        //                     dispatch(updateIsReload(true));
                        //                 })
                        //                 .catch((rejectedValueOrSerializedError) => {
                        //                 });
                        //         }
                        //     })
                        //     .catch((error) => {
                        //     });
                    }
                }
                // else if (hoursValue != 0 && validTime) {
                // else if (hoursValue != 0 && showClockStartEnd ? (hoursValue != currentDetailRow.Hours || isChanged) : validTime) {
                else if ((hoursValue != 0 && (hoursValue != currentDetailRow.Hours || isChanged || isClickTimeValue)) || (hoursValue == 0 && allowZeroHoursInTimesheet)) {  
                    // else if (hoursValue != 0 && (hoursValue != currentDetailRow.Hours || isChanged)) {
                    if (allowZeroHoursInTimesheet && isClearedWithBackspace) {
                        removeTimeEntries();
                    } else {
                        // isClickTimeValue && addUpdateTimeEntries(hoursValue, customFieldValues);
                        if (isClickTimeValue) {
                            addUpdateTimeEntries(hoursValue, customFieldValues);
                        } else if (isChanged) {
                            addUpdateTimeEntries(hoursValue, customFieldValues);
                        } else if (isChanged == false && isClickTimeValue == false && hoursValue > 0 && showClockStartEnd) {
                            addUpdateTimeEntries(hoursValue, customFieldValues);
                        }
                        oldTimeEntryValue = inputRef.current.value;
                    }
                    // let PostObject: TimesheetUpdateClass = {
                    //     AccountEmployeeTimeEntryPeriodId: accountEmployeeTimeEntryPeriodId,
                    //     AccountEmployeeTimeEntryApprovalProjectId: currentRow.AccountEmployeeTimeEntryApprovalProjectId,
                    //     AccountEmployeeTimeEntryId: currentDetailRow.AccountEmployeeTimeEntryId ? currentDetailRow.AccountEmployeeTimeEntryId : 0,
                    //     AccountEmployeeId: accountEmployeeId,
                    //     AccountClientId: currentRow.AccountClientId ? currentRow.AccountClientId : 0,
                    //     AccountProjectId: currentRow.AccountProjectId ? currentRow.AccountProjectId : 0,
                    //     AccountProjectTaskId: currentRow.AccountProjectTaskId ? currentRow.AccountProjectTaskId : 0,
                    //     AccountCostCenterId: currentRow.AccountCostCenterId ? currentRow.AccountCostCenterId : 0,
                    //     AccountWorkTypeId: showWorkType ? currentRow.AccountWorkTypeId : defaultWorkTypeId,
                    //     // AccountTimeOffTypeId: currentRow.AccountTimeOffTypeId ? currentRow.AccountTimeOffTypeId : null,
                    //     AccountTimeOffTypeId: currentRow.AccountTimeOffTypeId ? currentRow.AccountTimeOffTypeId : null,
                    //     Hours: hoursValue,
                    //     Percentage: null,
                    //     PeriodStartDate: startDate,
                    //     PeriodEndDate: endDate,
                    //     TimeEntryDate: currentDetailRow.TimeEntryDate,
                    //     // StartTime: showClockStartEnd && !decimalFormat ? customFieldValues.StartTime : null,
                    //     // EndTime: showClockStartEnd && !decimalFormat ? customFieldValues.EndTime : null,
                    //     StartTime: showClockStartEnd && !decimalFormat ? currentDetailRow.TimeEntryDate + " " + customFieldValues.StartTime + ":00" : null,
                    //     EndTime: showClockStartEnd && !decimalFormat ? currentDetailRow.TimeEntryDate + " " + customFieldValues.EndTime + ":00" : null,
                    //     IsTimeOff: (currentRow.isTimeOff === "1" || currentRow.isTimeOff) ? true : false,
                    //     TimesheetPeriodType: timeEntryViewType,
                    //     IsSubmitted: false,
                    //     Description: customFieldValues.Description,
                    //     CustomField1: customFieldValues.CustomField1,
                    //     CustomField2: customFieldValues.CustomField2,
                    //     CustomField3: customFieldValues.CustomField3,
                    //     CustomField4: customFieldValues.CustomField4,
                    //     CustomField5: customFieldValues.CustomField5,
                    //     CustomField6: customFieldValues.CustomField6,
                    //     CustomField7: customFieldValues.CustomField7,
                    //     CustomField8: customFieldValues.CustomField8,
                    //     CustomField9: customFieldValues.CustomField9,
                    //     CustomField10: customFieldValues.CustomField10,
                    //     CustomField11: customFieldValues.CustomField11,
                    //     CustomField12: customFieldValues.CustomField12,
                    //     CustomField13: customFieldValues.CustomField13,
                    //     CustomField14: customFieldValues.CustomField14,
                    //     CustomField15: customFieldValues.CustomField15,
                    //     RowId: rowId,
                    //     DetailRowId: detailRowId
                    // };
                    // if (PostObject.IsTimeOff) {
                    //     PostObject.AccountWorkTypeId = 0;
                    // }
                    // setValidTime(false);
                    // dispatch(updateDetailFieldsByDetailRowId(PostObject));
                    // if (isCopyActivities) {
                    //     let tempArray = [];
                    //     tempArray.push(PostObject)
                    //     dispatch(addCopyAccountEmployeeTimeEntryAsync(tempArray))
                    //         .unwrap()
                    //         .then((originalPromiseResult) => {
                    //             const { oldAccountEmployeeTimeEntryId } = originalPromiseResult;
                    //             if (oldAccountEmployeeTimeEntryId == 0) {
                    //                 ShowToast('Success', 'Time Entry Added Successfully!', "success", "toast-top-right");
                    //             }
                    //             else {
                    //                 ShowToast('Success', 'Time Entry Updated Successfully!', "success", "toast-top-right");
                    //             }
                    //         })
                    //         .catch((rejectedValueOrSerializedError) => {
                    //         })
                    //         .finally(() => {
                    //         });
                    // } else {
                    //     let isAllowEntries = false;
                    //     if (isAllowOverlappingTimeEntries == false && showClockStartEnd) {
                    //         let tempStartTime = PostObject.StartTime?.split(':');
                    //         let tempEndTime = PostObject.EndTime?.split(':');
                    //         timeEntriesList.map((item: any) => {
                    //             let getEntries = item.timeEntries.filter((x: any) => x.TimeEntryDate == PostObject.TimeEntryDate && x.AccountEmployeeTimeEntryId != null);
                    //             if (getEntries.length > 0) {
                    //                 getEntries.map((item: any) => {
                    //                     let startTime = item.StartTime.split(':');
                    //                     let endTime = item.EndTime.split(':');
                    //                     if (Number(startTime[0]) == Number(tempStartTime![0]) && Number(endTime[0]) <= Number(tempStartTime![0])) {
                    //                         isAllowEntries = true;
                    //                     } else if ((Number(endTime[0]) == Number(tempEndTime![0]) && Number(endTime[1]) <= Number(tempEndTime![1]))) {
                    //                         isAllowEntries = true;
                    //                     }
                    //                 })
                    //             }
                    //         });
                    //     }
                    //     if (isAllowEntries && isAllowOverlappingTimeEntries == false && showClockStartEnd) {
                    //         ShowToast('Warning', 'The time you entered is overlapping with existing Entry, please enter different time.', "warning", "toast-top-right");
                    //     } else {
                    //         dispatch(addUpdateAccountEmployeeTimeEntryAsync(PostObject))
                    //             .unwrap()
                    //             .then((originalPromiseResult) => {
                    //                 const { oldAccountEmployeeTimeEntryId } = originalPromiseResult;
                    //                 if (oldAccountEmployeeTimeEntryId == 0) {
                    //                     ShowToast('Success', 'Time Entry Added Successfully!', "success", "toast-top-right");
                    //                 }
                    //                 else {
                    //                     ShowToast('Success', 'Time Entry Updated Successfully!', "success", "toast-top-right");
                    //                 }
                    //             })
                    //             .catch((rejectedValueOrSerializedError) => {
                    //             })
                    //             .finally(() => {
                    //             });
                    //     }
                    //     // dispatch(addUpdateAccountEmployeeTimeEntryAsync(PostObject))
                    //     //     .unwrap()
                    //     //     .then((originalPromiseResult) => {
                    //     //         const { oldAccountEmployeeTimeEntryId } = originalPromiseResult;
                    //     //         if (oldAccountEmployeeTimeEntryId == 0) {
                    //     //             ShowToast('Success', 'Time Entry Added Successfully!', "success", "toast-top-right");
                    //     //         }
                    //     //         else {
                    //     //             ShowToast('Success', 'Time Entry Updated Successfully!', "success", "toast-top-right");
                    //     //         }
                    //     //     })
                    //     //     .catch((rejectedValueOrSerializedError) => {
                    //     //     })
                    //     //     .finally(() => {
                    //     //     });
                    // }
                }
            }
        }  
        setVisible(false);
    }
        const getFormattedCustomField = (fieldName: string, value: any) => {
        const field = customFieldsTemplate.find((item: any) => item.DatabaseFieldName === fieldName);
        // If field exists, is type Number, and has a value
        if (field && field.MasterCustomDataTypeName === 'Number' && value) {
            return value.toString().replace(',', '.');
        }
        return value;
    };

    const addUpdateTimeEntries = (hoursValue: number, customFieldValues: any, reasonForChange: string = '') => {
    const isRecordNotSubmitted = currentDetailRow?.status === "record-not-submitted";
    if (isLocked && !isRecordNotSubmitted) {
         ShowToast('Warning', 'Timesheet is locked.', 'warning', 'toast-top-right');
            return;
   }
        // Check if editing existing entry and changelog is enabled
        const isEditingExisting = Boolean(currentDetailRow.AccountEmployeeTimeEntryId);
        
        if (IsTimesheetChangelogEnabled && isEditingExisting && !reasonForChange) {
            setPendingUpdateData({ hoursValue, customFieldValues });
            setIsChangelogModalOpen(true);
            return;
        }
        isClickTimeValue = false;
        let PostObject: TimesheetUpdateClass = {
            AccountEmployeeTimeEntryPeriodId: accountEmployeeTimeEntryPeriodId,
            AccountEmployeeTimeEntryApprovalProjectId: currentRow.AccountEmployeeTimeEntryApprovalProjectId,
            AccountEmployeeTimeEntryId: currentDetailRow.AccountEmployeeTimeEntryId ? currentDetailRow.AccountEmployeeTimeEntryId : 0,
            AccountEmployeeId: accountEmployeeId,
            AccountClientId: currentRow.AccountClientId ? currentRow.AccountClientId : 0,
            AccountProjectId: currentRow.AccountProjectId ? currentRow.AccountProjectId : 0,
            AccountProjectTaskId: currentRow.AccountProjectTaskId ? currentRow.AccountProjectTaskId : 0,
            AccountCostCenterId: currentRow.AccountCostCenterId ? currentRow.AccountCostCenterId : 0,
            AccountWorkTypeId: showWorkType ? currentRow.AccountWorkTypeId : defaultWorkTypeId,
            // AccountTimeOffTypeId: currentRow.AccountTimeOffTypeId ? currentRow.AccountTimeOffTypeId : null,
            AccountTimeOffTypeId: currentRow.AccountTimeOffTypeId ? currentRow.AccountTimeOffTypeId : null,
            Hours: hoursValue,
            Percentage: null,
            PeriodStartDate: startDate,
            PeriodEndDate: endDate,
            TimeEntryDate: currentDetailRow.TimeEntryDate,
            // StartTime: showClockStartEnd && !decimalFormat ? customFieldValues.StartTime : null,
            // EndTime: showClockStartEnd && !decimalFormat ? customFieldValues.EndTime : null,
            StartTime: showClockStartEnd && !decimalFormat ? currentDetailRow.TimeEntryDate + " " + customFieldValues.StartTime + ":00" : null,
            EndTime: showClockStartEnd && !decimalFormat ? currentDetailRow.TimeEntryDate + " " + customFieldValues.EndTime + ":00" : null,
            IsTimeOff: (currentRow.isTimeOff === "1" || currentRow.isTimeOff) ? true : false,
            TimesheetPeriodType: timeEntryViewType,
            IsSubmitted: false,
            Description: customFieldValues.Description,
            Reason: (isEditingExisting && reasonForChange) ? reasonForChange : '',
            SystemPlatformSourceId: "3D9FD131-9B80-43DA-AD66-CBE010F1B5A6",
            CustomField1: getFormattedCustomField('CustomField1', customFieldValues.CustomField1),
            CustomField2: getFormattedCustomField('CustomField2', customFieldValues.CustomField2),
            CustomField3: getFormattedCustomField('CustomField3', customFieldValues.CustomField3),
            CustomField4: getFormattedCustomField('CustomField4', customFieldValues.CustomField4),
            CustomField5: getFormattedCustomField('CustomField5', customFieldValues.CustomField5),
            CustomField6: getFormattedCustomField('CustomField6', customFieldValues.CustomField6),
            CustomField7: getFormattedCustomField('CustomField7', customFieldValues.CustomField7),
            CustomField8: getFormattedCustomField('CustomField8', customFieldValues.CustomField8),
            CustomField9: getFormattedCustomField('CustomField9', customFieldValues.CustomField9),
            CustomField10: getFormattedCustomField('CustomField10', customFieldValues.CustomField10),
            CustomField11: getFormattedCustomField('CustomField11', customFieldValues.CustomField11),
            CustomField12: getFormattedCustomField('CustomField12', customFieldValues.CustomField12),
            CustomField13: getFormattedCustomField('CustomField13', customFieldValues.CustomField13),
            CustomField14: getFormattedCustomField('CustomField14', customFieldValues.CustomField14),
            CustomField15: getFormattedCustomField('CustomField15', customFieldValues.CustomField15),
            RowId: rowId,
            DetailRowId: detailRowId,
            TimeZoneId: timeZoneId
        };
        if (PostObject.IsTimeOff) {
            PostObject.AccountWorkTypeId = 0;
        }
        setValidTime(false);
        dispatch(updateDetailFieldsByDetailRowId(PostObject));
        if (isCopyActivities) {
            let tempArray = [];
            tempArray.push(PostObject)
            dispatch(addCopyAccountEmployeeTimeEntryAsync(tempArray))
                .unwrap()
                .then((originalPromiseResult) => {
                    const { oldAccountEmployeeTimeEntryId } = originalPromiseResult;
                    if (oldAccountEmployeeTimeEntryId == 0) {
                        ShowToast('Success', 'Time Entry Added Successfully!', "success", "toast-top-right");
                    }
                    else {
                        ShowToast('Success', 'Time Entry Updated Successfully!', "success", "toast-top-right");
                    }
                })
                .catch((rejectedValueOrSerializedError) => {
                })
                .finally(() => {
                });
        } else {
           
            // if (isAllowOverlappingTimeEntries == false && showClockStartEnd) {
            //    // let tempStartTime = PostObject.StartTime?.split(':');
            //    // let tempEndTime = PostObject.EndTime?.split(':');

            //     let tempStartTime = PostObject.StartTime?.split(" ")[1].split(":").slice(0,2);
            //     let tempEndTime = PostObject.EndTime?.split(" ")[1].split(":").slice(0,2);
            //     timeEntriesList.map((item: any) => {
            //         let getEntries = item.timeEntries.filter((x: any) => x.TimeEntryDate == PostObject.TimeEntryDate && x.AccountEmployeeTimeEntryId != null);
            //         if (getEntries.length > 0) {
            //             getEntries.map((item: any) => {
            //                 let startTime = item.StartTime.split(':');
            //                 let endTime = item.EndTime.split(':');                            
            //                 if (Number(startTime[0]) == Number(tempStartTime![0]) && Number(endTime[0]) <= Number(tempStartTime![0])) {
            //                     isAllowEntries = true;
            //                 } else if ((Number(endTime[0]) == Number(tempEndTime![0]) && Number(endTime[1]) <= Number(tempEndTime![1]))) {
            //                     isAllowEntries = true;
            //                 }
            //             })
            //         }
            //     });
            // } 
            if (decimalFormat == false && showClockStartEnd) {
                let startTimeStr: any = PostObject.StartTime?.includes(" ") ? PostObject.StartTime.split(" ")[1] : PostObject.StartTime;
                let endTimeStr: any = PostObject.EndTime?.includes(" ") ? PostObject.EndTime.split(" ")[1] : PostObject.EndTime;

                let [newStartH, newStartM] = startTimeStr.split(":").map(Number);
                let [newEndH, newEndM] = endTimeStr.split(":").map(Number);

                if (isNaN(newStartH) || isNaN(newStartM) || isNaN(newEndH) || isNaN(newEndM)) {
                    console.warn("Invalid StartTime or EndTime in PostObject:", PostObject);
                    return;
                }

                let newStart = newStartH * 60 + newStartM;
                let newEnd = newEndH * 60 + newEndM;
                let getEntries;
                timeEntriesList.forEach((item: any) => {
                    getEntries = item.timeEntries.filter(
                        (x: any) => x.TimeEntryDate == PostObject.TimeEntryDate
                    );

                    getEntries.forEach((entry: any) => {
                        let entryStartStr = entry.StartTime.includes(" ") ? entry.StartTime.split(" ")[1] : entry.StartTime;
                        let entryEndStr = entry.EndTime.includes(" ") ? entry.EndTime.split(" ")[1] : entry.EndTime;
                        let [sH, sM] = entryStartStr.split(":").map(Number);
                        let [eH, eM] = entryEndStr.split(":").map(Number);
                        if (isNaN(sH) || isNaN(sM) || isNaN(eH) || isNaN(eM)) {
                            console.warn("Invalid time format in entry:", entry);
                            return;
                        }
                        let entryStart = sH * 60 + sM;
                        let entryEnd = eH * 60 + eM;
                        if (newStart < entryEnd && newEnd > entryStart) {
                            isAllowEntries = true;
                        }
                    });
                });
            }
            if (isAllowEntries && isAllowOverlappingTimeEntries == false && showClockStartEnd) {
                ShowToast('Warning', 'The time you entered is overlapping with existing Entry, please enter different time.', "warning", "toast-top-right");
            } else {
                dispatch(addUpdateAccountEmployeeTimeEntryAsync(PostObject))
                    .unwrap()
                    .then((originalPromiseResult) => {
                        const { oldAccountEmployeeTimeEntryId } = originalPromiseResult;
                        if (oldAccountEmployeeTimeEntryId == 0) {
                            ShowToast('Success', 'Time Entry Added Successfully!', "success", "toast-top-right");
                        }
                        else {
                            ShowToast('Success', 'Time Entry Updated Successfully!', "success", "toast-top-right");
                        }
                    })
                    .catch((rejectedValueOrSerializedError) => {
                    })
                    .finally(() => {
                    });
            }
        }
    }

    const handleReasonSubmit = (reason: string) => {
        setIsChangelogModalOpen(false);
        if (pendingUpdateData) {
            
            addUpdateTimeEntries(pendingUpdateData.hoursValue, pendingUpdateData.customFieldValues, reason);
            setPendingUpdateData(null);
        }
    };

    const removeTimeEntries = () => {
        setShowPopover(false)
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "Removed entry will not be recovered", "Yes, Proceed")
            .then((result) => {
                dispatch(updateIsStateHour(false));
                dispatch(updateIsStateMinute(false));
                if (result) {
                    const { AccountClientId, AccountProjectId, AccountProjectTaskId, AccountEmployeeTimeEntryApprovalProjectId } = currentRow;
                    const postObject = {
                        AccountEmployeeId: accountEmployeeId,
                        AccountClientId,
                        AccountProjectId,
                        AccountProjectTaskId,
                        ApprovalProjectId: AccountEmployeeTimeEntryApprovalProjectId,
                        AccountEmployeeTimeEntryPeriodId: accountEmployeeTimeEntryPeriodId,
                        TimeEntries: [currentDetailRow.AccountEmployeeTimeEntryId],
                        IsTimeOff: currentRow.isTimeOff === "1" ? true : false,
                        IsDelete: true
                    }
                    dispatch(updateTimeEntriesAsync({ RowId: rowId, ...postObject }))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            dispatch(updateIsReload(true));
                        })
                        .catch((rejectedValueOrSerializedError) => {
                        });
                } else {
                    //setTimeEntryHours(oldTimeEntryValue === "" ? currentDetailRow.HoursDisplayText : oldTimeEntryValue);
                    setTimeEntryHours(displayValueForTimeEntry(currentDetailRow.Hours, isTimesheetPolicy, decimalFormat));
                    return;
                }
            })
            .catch((error) => {
            });
        isClearedWithBackspace = false;
        isClickTimeValue = false;
    }

   const handleChange = (e: any) => {
    const isRecordNotSubmitted = currentDetailRow?.status === "record-not-submitted";
    if (isLocked && !isRecordNotSubmitted) {
        return;
    } 
        let newValue = null;
        if (keyPressedName === "Backspace") {            
            newValue = e.target.value;
            if (newValue == "__:__" || newValue == "__.__") {
                isClearedWithBackspace = true;
            } else {
                isClearedWithBackspace = false;
            }
            setValidTime(true);
            setTimeEntryHours(e.target.value);
            e.preventDefault();
            e.stopPropagation();
            return;
        }        
        if (keyPressedName === "Delete") {
            removeTimeEntries();
            return;
        }
        if (!decimalFormat) {
            isClearedWithBackspace = false;
            newValue = e.target.value.replace(/_/g, "");
            let splitvalue = newValue.split(':');
            if (splitvalue[0] === "" && splitvalue[1] < 10) {
                if (splitvalue[1] > 0) {
                    lastInsertedMinutes = splitvalue[1];
                }
                updatedValue = `00:0${splitvalue[1]}`;
                dispatch(updateIsStateMinute(true));
                const input = document.querySelector(".hours-input") as HTMLInputElement;
                if (input) {
                    cursorPos = inputRef.current.selectionStart;
                }
            }
            else if (splitvalue[1] >= 10) {
                updatedValue = newValue;
            } else if (splitvalue[0] < 10 && splitvalue[0].length < 2) {
                tempHourValue = splitvalue[0];
                updatedValue = `0${splitvalue[0]}:${splitvalue[1] || "00"}`;
                dispatch(updateIsStateHour(true));
                lastInsertedMinutes = 0;      
            } else if (splitvalue[0] >= 10 && splitvalue[0].length === 2) {
                updatedValue = `${splitvalue[0]}:${splitvalue[1] || "00"}`;
            } else {
                if (tempHourValue > 0 && lastInsertedMinutes == 0) {
                    if (!isStateHour) {
                        tempHourValue = 0;
                        updatedValue = newValue;
                    } else {
                        const input = document.querySelector(".hours-input") as HTMLInputElement;
                        if (input) {
                            cursorPos = inputRef.current.selectionStart;
                        }
                        updatedValue = inputRef.current.selectionStart > 3 ? `${splitvalue[0]}:${splitvalue[1] || "00"}` : tempHourValue + splitvalue[0].split('')[1] + ':' + splitvalue[1];
                        tempHourValue = 0;
                    }

                } else {
                    tempHourValue = 0;
                    updatedValue = newValue;
                    if (lastInsertedMinutes > 0 && cursorPos != 5) {
                        if (isStateMinute) {
                            let splitMinutes = newValue.split(':');
                            tempHourValue = 0;
                            updatedValue = `${splitMinutes[0]}:${lastInsertedMinutes}${splitMinutes[1].split('')[1]}`;
                            lastInsertedMinutes = 0;
                        } else {
                            tempHourValue = 0;
                            updatedValue = newValue;
                        }
                    } else {
                        tempHourValue = 0;
                        updatedValue = newValue;
                    }
                }
            }
            let finalValue = updatedValue.split(':');
            if (Number(finalValue[0]) > 23) {
                setValidationEnable(true);
                let Object = {
                    rowId: rowId,
                    detailRowId: detailRowId,
                    message: `${currentDetailRow.TimeEntryDate} ${updatedValue} Invalid Time! Time must be less than 24:00`,
                    // hours: fixAndSetHoursValue(updatedValue)
                    hours: Number(fixAndSetHoursValue(updatedValue)).toFixed(2)
                }
                isClickTimeValue = false;
                dispatch(updateInValidTimeError(Object));
                return;
            } else if (Number(finalValue[1]) > 59) {
                setValidationEnable(true);
                let Object = {
                    rowId: rowId,
                    detailRowId: detailRowId,
                    message: `${currentDetailRow.TimeEntryDate} ${updatedValue} Invalid Time! Time must be less than 24:00`,
                    // hours: fixAndSetHoursValue(updatedValue)
                    hours: Number(fixAndSetHoursValue(updatedValue)).toFixed(2)     
                }
                isClickTimeValue = false;
                dispatch(updateInValidTimeError(Object));
                return;
            } else {
                if (validationEnable) {
                    let Object = {
                        rowId: rowId,
                        detailRowId: detailRowId,
                        message: '',
                        hours: fixAndSetHoursValue(updatedValue)
                    }
                    dispatch(updateValidTimeError(Object));
                    setValidationEnable(false);
                }
            }
            setTimeEntryHours(updatedValue);
            isClickTimeValue = true;
            setValidTime(true);
            setAllowInReactMask(1);
            e.preventDefault();
            e.stopPropagation();
            return;

        } else {         
            isClearedWithBackspace = false;
            // newValue = e.target.value.replace(/_/g, "");
            newValue = e.target.value.replace(/_/g, "").replace(/,/g, ".");
            let splitvalue = newValue.split('.');
            if (keyPressedName === "." && splitvalue[0].length > 0) {
                lastKeyName = keyPressedName;
            }
            const input = document.querySelector(".hours-input") as HTMLInputElement;
            if (keyPressedName === "." && splitvalue[0].length === 0) {
                tempHourValue = splitvalue[0];
                updatedValue = `00.`;
                setTimeout(() => {
                    if (input) {
                        input.setSelectionRange(3, 3);
                    }
                }, 0);
            }
            else if (keyPressedName === "." && splitvalue[0].length > 0) {
                setTimeout(() => {
                    if (input) {
                        input.setSelectionRange(3, 3);
                    }
                }, 0);
                updatedValue = `${splitvalue[0]}.${splitvalue[1]}`;
            }
            else if (splitvalue[0] === "" && splitvalue[1] < 10) {
                if (splitvalue[1] > 0) {
                    lastInsertedMinutes = splitvalue[1];
                }
                updatedValue = `00.0${splitvalue[1]}`;
                dispatch(updateIsStateMinute(true));
                 const input = document.querySelector(".hours-input") as HTMLInputElement;
                if (input) {                   
                    // Get current cursor position
                    cursorPos = inputRef.current.selectionStart;
                }   
            } else if (splitvalue[1] >= 10) {
                updatedValue = newValue;
            }
            else if (splitvalue[0] < 10 && splitvalue[0].length < 2) {
                tempHourValue = splitvalue[0];
                updatedValue = `0${splitvalue[0]}.${splitvalue[1] || "00"}`;
                dispatch(updateIsStateHour(true));
                lastInsertedMinutes = 0;
            } else if (splitvalue[0] >= 10 && splitvalue[0].length === 2) {
                updatedValue = `${splitvalue[0]}.${splitvalue[1] || "00"}`;
            }
            else {
                if (tempHourValue > 0 && lastInsertedMinutes == 0 ) {
                    if (lastKeyName == ".") {
                        updatedValue = splitvalue[0] + splitvalue[1];
                    } else {
                        if (isStateHour) {
                            const input = document.querySelector(".hours-input") as HTMLInputElement;
                            if (input) {
                                cursorPos = inputRef.current.selectionStart;
                            }
                            updatedValue = inputRef.current.selectionStart > 3 ? `${splitvalue[0]}.${splitvalue[1] || "00"}` : tempHourValue + splitvalue[0].split('')[1] + '.' + splitvalue[1];
                           // updatedValue = tempHourValue + splitvalue[0].split('')[1] + '.' + splitvalue[1];
                        } else {
                            tempHourValue = 0;
                            updatedValue = newValue;
                        }

                    }
                    tempHourValue = 0;
                } else {
                    tempHourValue = 0;
                    if (lastInsertedMinutes > 0 && cursorPos != 5) {
                        if (isStateMinute) {
                            let splitMinutes = newValue.split('.');
                            tempHourValue = 0;
                            updatedValue = `${splitMinutes[0]}.${lastInsertedMinutes}${splitMinutes[1].split('')[1]}`;
                        } else {
                            tempHourValue = 0;
                            updatedValue = newValue;
                        }
                    } else {
                        tempHourValue = 0;
                        updatedValue = newValue;
                    }
                }
                lastKeyName = "";
            }
            if (Number(updatedValue) > 23.99 || e.length > 5) {
                setValidationEnable(true);
                let Object = {
                    rowId: rowId,
                    detailRowId: detailRowId,
                    message: `${currentDetailRow.TimeEntryDate} ${updatedValue} Invalid Time! Time must be less than 23.99`,
                    hours: fixAndSetHoursValue(updatedValue)
                }
                dispatch(updateInValidTimeError(Object));
                e.preventDefault();
                e.stopPropagation();
                return;
            } else {
                if (validationEnable) {
                    let Object = {
                        rowId: rowId,
                        detailRowId: detailRowId,
                        message: '',
                        hours: fixAndSetHoursValue(updatedValue)
                    }
                    dispatch(updateValidTimeError(Object));
                    setValidationEnable(false);
                }
            }
            setTimeEntryHours(updatedValue);
            isClickTimeValue = true;
            setValidTime(true);
            setAllowInReactMask(1);
            e.preventDefault();
            e.stopPropagation();
            return;
        }
    }

    const fixAndSetHoursValue = (value: string) => {
        let newValue = null;
        if (decimalFormat) {
            const dReg1 = /^(2[0-3]|[01]?[0-9]).([0-9]?[0-9])$/;
            const dReg = /^([0-9]{1,2})(\.[0-9]{1,2})?$/;
           // newValue = dReg.test(value) ? parseFloat(value).toFixed(2) : FormatInvoiceDecimalNumber(cultureInfoName.toString(), Number(0.00), decimalPlaces);
             newValue = dReg.test(value) ? parseFloat(value).toFixed(2) : 0.00;
            //newValue = getDecimalFromTime(dReg.test(value) ? value.replace(/ /g, "0") : value);
        } else {
            const reg = new RegExp(/[0-9]+/);
            newValue = (reg.test(value) ? value.replace(/_/g, "0") : value);
        }
        return getDecimalFromTime(newValue, decimalFormat);
    }

    const onKeyUpHandler = (e: any) => {
            if (!decimalFormat) {
            const newValue = e.target.value.replace(/_/g, 0);
            const isValid = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(newValue);
            if (!isValid) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
        }
        // else {
        //     const newValue = e.target.value.replace(/_/g, 0);
        //     // newValue = parseFloat(e.target.value);
        //     const dReg = /^([0-9]{1,2})(\.[0-9]{1,2})?$/;
        //     //newValue = dReg.test(e.target.value) ? parseFloat(e.target.value).toFixed(2) : 0.00;
        //     //newValue = e.target.value
        //     if (!dReg.test(newValue)) {
        //         e.preventDefault();
        //         e.stopPropagation();
        //         return;
        //     }
        // }
    }

    const handleKeyPress = (e: any) => {
        keyPressedName = e.key;       
    }
    //Add event listener using our hook
    //useEventListener("mousedown", handleClick);

    useEffect(() => {
        document.addEventListener("mousedown", handleClick);
        dispatch(updateRefreshPrint(true));
        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
    }, [timeEntriesList]);

    // useEffect(() => {
    //     const handleKeyPress = (event: any) => {
    //         if (event.key === 'Tab' && fromTabIndex) {
    //             //fromTabIndex && event.preventDefault();
    //             handleClick(event);
    //             //dispatch(updateTabIndex(false));
    //         }
    //     };
    //     document.addEventListener('keydown', handleKeyPress);
    //     return () => {
    //         document.removeEventListener('keydown', handleKeyPress);
    //         document.removeEventListener("mousedown", handleClick);
    //     };
    // }, [timeEntriesList, fromTabIndex])

    useEffect(() => {
        if (currentDetailRow.ErrorMessage !== "" && currentDetailRow.ErrorMessage !==  "Description is required."){
            setTimeEntryHours(convertDecimalToTimeOnValidation(currentDetailRow.Hours, isTimesheetPolicy, decimalFormat));
        }      
        else {
            if (isAllowEntries && isAllowOverlappingTimeEntries == false && showClockStartEnd) {
                setTimeEntryHours(decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), Number(0.00), 2) : "00:00");
                setTimeEntryHours(displayValueForTimeEntry(0, isTimesheetPolicy, decimalFormat));
                isAllowEntries = false;               
            }else{
                //setTimeEntryHours(displayValueForTimeEntry(currentDetailRow.Hours, isTimesheetPolicy, decimalFormat));
                setTimeEntryHours(decimalFormat ? FormatInvoiceDecimalNumberWithTwoDigitInteger(cultureInfoName.toString(), (currentDetailRow.Hours), 2): displayValueForTimeEntry(currentDetailRow.Hours, isTimesheetPolicy, decimalFormat));                 
            }
           
            
        }
        //setTimeEntryHours(displayValueForTimeEntry(currentDetailRow.Hours, isTimesheetPolicy, decimalFormat));
    }, [currentDetailRow]);

    let placeholder = "00:00";
    let formatCharsForTimeInput = {
        '1': '[0-2]',
        '2': '[0-9]',
        '3': '[0-5]',
        '4': '[0-9]'
    };
    let formatCharsForDecimalInput = {
        '1': '[0-23]',
        '2': '[0-9]',
        '3': '[0-9]'
    };
    const mask = [/[0-2]/, /[0-3]/, '.', /[0-9]/, /[0-9]/];

    const onSpanClick = () => {
        if (!currentRow.AccountProjectId && !currentRow.isTimeOff) {
            ShowToast('Error', `No Project Selected`, "error", "toast-top-right");
            return;
        }
        if (!currentRow.AccountTimeOffTypeId && currentRow.isTimeOff) {
            ShowToast('Error', `No Time Off Type Selected`, "error", "toast-top-right");
            return;
        }
        setVisible(true);
        setShowPopover(true)
    }

    const beforeMaskedStateChange = (newState: BeforeMaskedStateChangeStates) => {
        let { previousState, currentState, nextState } = newState;
        let { value, selection } = nextState;
        if (value.startsWith('2'))
            formatCharsForTimeInput['2'] = '[0-3]';
        else
            formatCharsForTimeInput['2'] = '[0-9]';
        return {
            ...nextState,
            selection,
            value
        }
    }

    const onInputRef = (el: any) => {
        inputRef.current = el;
    }

    return (
        <td ref={node} className={"day " + (currentDetailRow.isDayOff == 1 ? 'record-DayOff' : (null != currentDetailRow.status && currentDetailRow.status))} style={timeEntryViewType === "Daily" ? {} : { position: "relative" }}>
            {/* {!visible && <span className={`duration-value`} onClick={onSpanClick}>{timeEntryHours}</span>} */}
            {/* {!visible && ((allowZeroHoursInTimesheet && currentDetailRow.AccountEmployeeTimeEntryId != null) ? <span className={`duration-value`} onClick={onSpanClick}>{timeEntryHours}</span> : 
            <span className={`duration-value hidden-value`} onClick={onSpanClick}>{timeEntryHours}</span>)} */}
            {!visible && <span className={clsx('duration-value prevent-select', allowZeroHoursInTimesheet ? currentDetailRow.AccountEmployeeTimeEntryId != null ? '' : 'hidden-value' : '')} onClick={onSpanClick}>{timeEntryHours}</span>}
            {visible &&
                <div className={`input-container`}>
                    {/* {isLocked ?
                        <input 
                           className={"hours-input"}
                            onChange={e => handleChange(e.target.value)}
                            type="text"
                            defaultValue={currentDetailRow.Hours}
                            disabled={true}
                            readOnly={true}
                            placeholder={placeholder} />
                        :
                        // decimalFormat ?
                        //     <ReactInputMask
                        //         className={"hours-input"}
                        //         onChange={e => handleChange(e)}
                        //         //onBlur={e => handleFocusOut(e.target.value)}
                        //         ref={el => onInputRef(el)}
                        //         mask={"99.99"}
                        //         //beforeMaskedValueChange={beforeMaskedValueChange}
                        //         autoFocus={visible}
                        //         value={timeEntryHours}
                        //     />
                        //     :
                    } */}
                    {/* dropdownVisible && isTimeOff === true && AccountTimeOffType == null && */}
                    <ReactInputMask
                        className={"hours-input"}
                        onKeyUp={onKeyUpHandler}
                        onKeyDown={handleKeyPress}
                        onChange={e => handleChange(e)}
                        // mask={decimalFormat ? (timeEntryHours.toString().length == 5 ? "99.99" : "99.99") : "99:99"}
                        mask={decimalFormat ? (timeEntryHours.toString().length == 5 ? "99"+formatlabel+"99" : "99"+formatlabel+"99") : "99:99"}
                        // //beforeMaskedStateChange={beforeMaskedStateChange}
                        ref={el => onInputRef(el)}
                        autoFocus={visible}
                        alwaysShowMask={true}
                        // readOnly={isLocked ? true : false}
                       // readOnly={isLocked ? true : currentRow.AccountEmployeeTimeOffRequestId != null ? true : false}
                       readOnly={(isLocked && currentDetailRow?.status !== "record-not-submitted") ? true : currentRow.AccountEmployeeTimeOffRequestId != null ? true : false}
                        // readOnly={isLocked ? true : currentRow.isTimeOff ? currentDetailRow.AccountEmployeeTimeEntryId != null ? true : true : false}
                        // maskPlaceholder={decimalFormat ? (timeEntryHours.toString().length == 5 ? "__.__" : "__.__") : "__:__"}
                        maskPlaceholder={decimalFormat ? (timeEntryHours.toString().length == 5 ? "__"+formatlabel+"__" : "__"+formatlabel+"__") : "__:__"}
                        // value={timeEntryHours == 0.00 ? "00.00" : timeEntryHours}
                        value={decimalFormat ? (currentDetailRow.AccountEmployeeTimeEntryId == null ? allowInReactMask == 0 ? "__"+formatlabel+"__" : timeEntryHours : timeEntryHours) :
                            (currentDetailRow.AccountEmployeeTimeEntryId == null ? allowInReactMask == 0 ? "__:__" : timeEntryHours : timeEntryHours)}

      
                        // disabled={showClockStartEnd && !decimalFormat}
                        disabled={currentDetailRow.isLockPreviousNextTimesheetsOn ? true : (showClockStartEnd && !decimalFormat) || (currentDetailRow.isDayOff == 1 ? true : false)}
                    // disabled={(showClockStartEnd && !decimalFormat) || (currentDetailRow.isDayOff == 1 ? true : false)}
                    />
                    {showpopover && currentDetailRow.isDayOff == 0 && (currentRow.isTimeOff !== "1") && currentDetailRow.isLockPreviousNextTimesheetsOn != true &&
                        <CustomFieldPopover
                            ref={popoverRef}
                            id={currentDetailRow.AccountEmployeeTimeEntryId}
                            timeEntryHours={timeEntryHours}
                            rowId={currentDetailRow.rowId}
                            detailRowId={detailRowId}
                            status={currentDetailRow.status}
                            showRelative={showRelative}
                        />
                    }
                    {showpopover && currentDetailRow.isDayOff == 0 && (currentRow.isTimeOff === "1") && (currentDetailRow.AccountEmployeeTimeEntryId != null && currentRow.AccountEmployeeTimeOffRequestId != null) &&
                        <CustomFieldPopover
                            ref={popoverRef}
                            id={currentDetailRow.AccountEmployeeTimeEntryId}
                            timeEntryHours={timeEntryHours}
                            rowId={currentDetailRow.rowId}
                            detailRowId={detailRowId}
                            status={currentDetailRow.status}
                            showRelative={showRelative}
                        />
                    }
                    {showpopover && currentDetailRow.isDayOff == 0 && (currentRow.isTimeOff === "1") && (currentRow.AccountEmployeeTimeOffRequestId === null) &&
                        <CustomFieldPopover
                            ref={popoverRef}
                            id={currentDetailRow.AccountEmployeeTimeEntryId}
                            timeEntryHours={timeEntryHours}
                            rowId={currentDetailRow.rowId}
                            detailRowId={detailRowId}
                            status={currentDetailRow.status}
                            showRelative={showRelative}
                        />
                    }
                    {/* {currentDetailRow.isDayOff == 0 && (currentRow.isTimeOff === "1") && currentRow.AccountTimeOffType != null && currentDetailRow.AccountEmployeeTimeEntryId != null &&
                        <CustomFieldPopover
                            ref={popoverRef}
                            id={currentDetailRow.AccountEmployeeTimeEntryId}
                            timeEntryHours={timeEntryHours}
                            rowId={currentDetailRow.rowId}
                            detailRowId={detailRowId}
                            status={currentDetailRow.status}
                        />
                    } */}
                </div>
            }
       
       <ChangelogReasonModal
                isOpen={isChangelogModalOpen}
                onClose={() => setIsChangelogModalOpen(false)}
                onSubmit={handleReasonSubmit}
            />
        </td>
        
    );
}

export default TimeEntryInput